// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"GtinImagesTab_subTitle__12h78"};